module.exports = __webpack_public_path__ + "static/media/gatling.0840e53e.jpg";